"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var slug_1 = __importDefault(require("slug"));

var produitPriceByTarification_1 = __importDefault(require("./produitPriceByTarification"));

var convertProduitTypeToNode = function convertProduitTypeToNode(produit, datas) {
  var _a, _b, _c, _d, _e;

  var newPrice;
  var newPriceDisplayMode;
  var price = datas && (0, produitPriceByTarification_1.default)(datas.prices, datas.tarification, datas.tarificationDocument);

  if (price) {
    newPrice = price.amount;
    newPriceDisplayMode = price.displayMode;
  }

  if (newPrice && (datas === null || datas === void 0 ? void 0 : datas.priceVariation)) {
    newPrice = newPrice * datas.priceVariation / 100;
  }

  if (datas === null || datas === void 0 ? void 0 : datas.priceDisplayMode) {
    switch (datas.priceDisplayMode) {
      case 'hidden':
        {
          newPriceDisplayMode = undefined;
          break;
        }

      case 'show':
      case 'request':
        {
          newPriceDisplayMode = datas.priceDisplayMode;
          break;
        }

      case 'legacy':
      default:
    }
  }

  var qtyAvailable = produit.qtyAvailable || 0;
  var qtyMax = produit.qtyMax ? Math.min(produit.qtyMax, qtyAvailable) : qtyAvailable;
  var qtyMin = produit.qtyMin || 0;
  var qtyByNumber = produit.qtyByNumber || 1;
  return {
    qtyAvailable: qtyAvailable,
    qtyByNumber: qtyByNumber,
    categoryIds: ((_a = produit.search) === null || _a === void 0 ? void 0 : _a.categories) ? produit.search.categories : undefined,
    children: [],
    condition: produit.condition || 'new',
    datetime: Number(produit.datetime),
    deleted: Boolean(produit.deleted),
    depth: produit.depth || undefined,
    description: produit.description,
    dimensions: produit.dimensions && produit.dimensions.length > 0 ? produit.dimensions : undefined,
    foldedDepth: produit.foldedDepth,
    foldedHeight: produit.foldedHeight,
    foldedWidth: produit.foldedWidth,
    hasInventory: Boolean(produit.hasInventory),
    height: produit.height || undefined,
    hidden: Boolean(produit.hidden),
    isALot: Boolean(produit.isALot),
    isDemountable: Boolean(produit.isDemountable),
    isDigital: !produit.isPhysical,
    isFeatured: Boolean(produit.isFeatured),
    isFragile: Boolean(produit.isFragile),
    isHeavy: Boolean(produit.isHeavy),
    isOnSale: !produit.hasInventory || undefined !== produit.qtyAvailable && produit.qtyAvailable > 0,
    isStackable: Boolean(produit.isStackable),
    keywords: produit.keywords,
    kind: (_b = produit.kind) !== null && _b !== void 0 ? _b : 'good',
    medias: produit.medias,
    metaDescription: produit.metaDescription,
    metaKeywords: produit.metaKeywords,
    name: String(produit.name),
    parent: undefined,
    pathname: (0, slug_1.default)("".concat(produit.name, " ").concat(produit.datetime)),
    price: newPrice,
    priceDisplayMode: newPriceDisplayMode,
    qtyInLot: produit.qtyInLot,
    qtyMax: !produit.hasInventory ? 0 : qtyMax,
    qtyMin: Math.max(1, Math.min(qtyMin, qtyAvailable), qtyByNumber),
    qtyPrices: (_c = produit.qtyPrices) !== null && _c !== void 0 ? _c : 0,
    qtyReserved: (_d = produit.qtyReserved) !== null && _d !== void 0 ? _d : 0,
    qtySlots: (_e = produit.qtySlots) !== null && _e !== void 0 ? _e : 0,
    reference: produit.reference,
    shipping2Carriers: Boolean(produit.shipping2Carriers),
    shippingFloor: produit.shippingFloor || 'valid',
    shippingMode: produit.shippingMode || 'auto',
    shippingRisky: Boolean(produit.shippingRisky),
    shippingSharing: produit.shippingSharing,
    shippingSupport: produit.shippingSupport,
    shippingVolume: produit.shippingVolume,
    shippingWeight: produit.shippingWeight,
    shortname: produit.shortname,
    sku: produit.sku,
    stackableByQty: produit.stackableByQty,
    title: produit.title,
    traductions: produit.traductions,
    weight: produit.weight || undefined,
    width: produit.width || undefined
  };
};

exports.default = convertProduitTypeToNode;